import React from "react";
import "./Pincode.css";
import rest from "./restService";
import {useHistory} from "react-router";

export default function Pincode() {
    let input = '';
    let dots = React.createRef();
    let msg = React.createRef();
    let restService = new rest();
    let history = useHistory();
    let active = true;

    function clickNumber(e, number) {
        input += number;
        let numberElm = e.target;
        numberElm.className += ' grow';
        dots.current.children[input.length - 1].className += ' active';
        msg.current.innerText = '';
        if (input.length >= 4) {
            restService.checkPin(input, (data) => {
                    //correct
                    if (data !== "\"error\"") {
                        //correct
                        let res = JSON.parse(data);
                        localStorage.setItem('posuser', JSON.stringify(res.posuser));
                        localStorage.setItem('stantion_id', res.stantion_id);
                        localStorage.setItem('tables', JSON.stringify(res.tables));
                        localStorage.setItem('org-name', res.org_name);
                        if (active)
                            for (let i = 0; i < dots.current.children.length; i++) {
                                //dots.current.children[i].className += " correct";
                            }
                        history.push("/tsd");
                        active = false;
                    } else {
                        //wrong
                        for (let i = 0; i < dots.current.children.length; i++) {
                            dots.current.children[i].className += " wrong";
                        }
                        msg.current.innerText = 'Невірний пін';
                    }
                }
                ,
                (e) => {
                }
            );
            input = "";
            setTimeout(() => {
                if (active)
                    for (let i = 0; i < dots.current.children.length; i++) {
                        dots.current.children[i].className = "dot";
                    }
            }, 900);
        }

        setTimeout(function () {
            numberElm.className = "number";
        }, 500)
    }

    return (
        <div id="pin">
            <div className="dots" ref={dots}>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
            <p ref={msg}></p>
            <div className="numbers">
                <div className="number" onClick={(e) => clickNumber(e, 1)}>1</div>
                <div className="number" onClick={(e) => clickNumber(e, 2)}>2</div>
                <div className="number" onClick={(e) => clickNumber(e, 3)}>3</div>
                <div className="number" onClick={(e) => clickNumber(e, 4)}>4</div>
                <div className="number" onClick={(e) => clickNumber(e, 5)}>5</div>
                <div className="number" onClick={(e) => clickNumber(e, 6)}>6</div>
                <div className="number" onClick={(e) => clickNumber(e, 7)}>7</div>
                <div className="number" onClick={(e) => clickNumber(e, 8)}>8</div>
                <div className="number" onClick={(e) => clickNumber(e, 9)}>9</div>
                <div className="number" onClick={(e) => clickNumber(e, 0)}>0</div>
            </div>
        </div>
    )
}